import React from 'react';
import { Col, Row } from 'reactstrap';
import _ from 'lodash'
import api from '../../api';
import BigQuery from '../../components/connectors/BigQuery';
import RDBMS from '../../components/connectors/RDBMS';
import Presto from '../../components/connectors/Presto'
import './index.css';

// The Roster component matches one of two different routes
// depending on the full pathname
export default class DatasourceEditScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datasource: {
                id: parseInt(this.props.match.params.datasource_id, 10) || '',
                code_name: '',
                description: '',
                name: '',
                databases: [],
                extra_data: {
                    ignored_datasets: '',
                },
            },
        }
    }
    componentWillMount() {
        this.getDatasource();
    }
    componentDidMount = () => {
    }
    getDatasource() {
        const { datasource } = this.state;
        let uri = `datasource/${datasource.id}`;
        api.fetchAPI({
            method: 'get',
            uri,
            success: (response) => {
                if (response.status == 'ok') {
                    const datasource = response.datasource;
                    console.log(datasource);
                    this.setState({ datasource });
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    render() {
        const { datasource } = this.state;
        let datasourceComponent = null;
        switch(datasource.datasource_type) {
            case 'bigquery':
                datasourceComponent = <BigQuery datasource={datasource} />
            case 'postgres':
                datasourceComponent = <RDBMS datasource={datasource} />
            case 'mysql':
                datasourceComponent = <RDBMS datasource={datasource} />
            case 'presto':
                datasourceComponent = <Presto datasource={datasource} />
            default:
                // code block
        }

        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <h1>Edit {datasource.code_name}</h1>
                    </Col>
                    {datasourceComponent}
                </Row>
            </div>
        )
    };
}



// WEBPACK FOOTER //
// ./src/pages/DatasourceEdit/index.js